<template>
    <div class="lg:p-12 bg-gray-100 rounded p-4">
        <h2 class="text-3xl font-bold text-center text-themeColor mb-4">
            Login
        </h2>

        <b-loading
            :is-full-page="true"
            v-model="loading"
            :can-cancel="false"
        ></b-loading>

        <div class="mb-4">
            <label
                class="block text-gray-700 text-base font-bold mb-2"
                for="email"
            >
                {{ $t('account.email') }}
            </label>
            <input
                v-model="email"
                id="email"
                class="appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="email"
                placeholder="patrickmartin@domaine.fr"
            />
        </div>
        <p
            v-if="
                (isSubmit && mailMessage) ||
                (isForgotPasswordSubmit && mailMessage)
            "
            class="has-text-danger font-bold text-center is-size-7"
        >
            {{ mailMessage }}
        </p>
        <div class="mb-4">
            <label
                class="block text-gray-700 text-base font-bold mb-2"
                for="password"
            >
                {{ $t('account.register.password') }}
            </label>
            <input
                @keypress.enter="doLogin"
                v-model="password"
                id="password"
                class="appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="password"
                placeholder="********"
            />
        </div>
        <p
            v-if="isSubmit && passwordMessage"
            class="has-text-danger font-bold text-center is-size-7"
        >
            {{ passwordMessage }}
        </p>

        <div class="mt-5">
            <button
                id="loginBtn"
                @click.prevent="doLogin"
                class="text-base font-bold text-center bg-themeColor text-white hover-bg-secondaryColor rounded w-full py-3"
            >
                {{ $t('account.register.log_in') }}
            </button>
        </div>
        <div class="text-center mt-2">
            <span
                v-if="isloadingForgotPwd"
                aria-hidden="true"
                class="spinner-border spinner-border-sm"
                role="status"
            ></span>
            <div class="btn btn-link" @click.prevent="forgotPasswordHandler">
                {{ $t('auth.forgot_password.submit') }}
            </div>
        </div>
        <p
            v-if="isForgotPasswordSubmit && passwordResetMessage"
            class="has-text-danger font-bold text-center is-size-7"
        >
            {{ passwordResetMessage }}
        </p>
    </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
    name: 'Login',
    data() {
        return {
            isSubmit: false,
            loading: false,
            isloadingForgotPwd: false,
            email: null,
            password: null,
            isForgotPasswordSubmit: false,
            passwordResetMessage: '',
            mailMessage: '',
            passwordMessage: '',
            mailregExp:
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        }
    },
    methods: {
        ...mapMutations('post', ['setPosts']),
        ...mapActions('auth', ['login', 'forgotPassword']),
        ...mapActions('post', ['getPosts']),
        doLogin() {
            this.loading = true
            this.isSubmit = true
            this.confirmMail(this.email)
            this.confirmPassword(this.password)
            !this.mailMessage && !this.passwordMessage
                ? this.login({ email: this.email, password: this.password })
                      .then(() => {
                          this.loading = false
                          this.isSubmit = true
                          this.setPosts(null)
                          this.getPosts()
                              .then(() => {
                                  this.$router.push('/')
                              })
                              .catch((e) => {
                                  this.$store.dispatch('toastError', e)
                                  this.$router.push('/')
                              })
                      })
                      .catch((e) => {
                          this.$store.dispatch('toastError', e)
                      })
                      .finally(() => {
                          this.loading = false
                      })
                : (this.loading = false)
        },
        forgotPasswordHandler() {
            this.loading = true
            this.isForgotPasswordSubmit = true
            this.confirmMail(this.email)
            !this.mailMessage
                ? this.forgotPassword(this.email)
                      .then(() => {
                          this.loading = false
                          this.passwordResetMessage = this.$t(
                              'auth.forgot_password.success_message'
                          )
                      })
                      .catch((error) => {
                          this.loading = false
                          this.$store.dispatch('dispatchError', error)
                      })
                : (this.loading = false)
        },
        // vérifie la saisie du champ email
        confirmMail(email) {
            if (!email) {
                this.mailMessage = this.$t('error.validation.required')
            } else if (!this.mailregExp.test(email)) {
                this.mailMessage = this.$t('error.validation.mail_valid')
            } else {
                this.mailMessage = ''
            }
        },
        confirmPassword(password) {
            if (!password) {
                this.passwordMessage = this.$t('error.validation.required')
            } else {
                this.passwordMessage = ''
            }
        }
    },
    mounted() {
        if (this.$store.state.auth.isConnected) {
            this.$router.push('/')
        }
    }
}
</script>

<style scoped></style>
